<script>
import api from '../../../helpers/apirest/api';
/**
 * Widget Component
 */
export default {
  data() {
    return {
      statData: [
        {
          id: 1,
          title: "Active Customers",
          icon: "bx ri-team-fill",
          value: "0",
          subvalue: "",
          loading: false,
          url: "customers"
        },
        {
          id: 2,
          title: "Active sync tasks",
          icon: "bx ri-list-check-2",
          value: "0",
          subvalue: "",
          loading: false,
          url: "customer-tasks"
        },
        {
          id: 3,
          title: "Active raw command tasks",
          icon: "ri-list-check",
          value: "0",
          subvalue: "",
          loading: false,
          url: "customer-tasks-raw-command"
        }
      ]
    };
  },
  created(){
    this.loadActiveCustomers();
    this.loadActiveSyncTasks();
    this.loadActiveRawCommandTasks();
  },
  methods:{
    async loadActiveCustomers(){
      const item = this.statData.find(({id}) => id === 1);
      
      try{
        item.loading = true;
        const data = await api.get({
          url: 'customers-count',
          params: {
            'status': 1
          }
        });
        
        item.value = data?.data?.data?.count || '';
        item.loading = false;
      }catch(error){
        item.loading = false
      }
    }, 
    async loadActiveSyncTasks(){
      const item = this.statData.find(({id}) => id === 2);
      
      try{
        item.loading = true;
        const data = await api.get({
          url: 'customer-tasks-count',
          params: {
            'only_sync_task': 1,
            'status': 1
          }
        });
        
        item.value = data?.data?.data?.count || '';
        item.loading = false;
      }catch(error){
        item.loading = false
      }
    },    
    async loadActiveRawCommandTasks(){
      const item = this.statData.find(({id}) => id === 3);
      
      try{
        item.loading = true;
        const data = await api.get({
          url: 'customer-tasks-count',
          params: {
            'only_raw_command_task': 1,
            'status': 1
          }
        });
        
        item.value = data?.data?.data?.count || '';
        item.loading = false;
      }catch(error){
        item.loading = false
      }
    }
  }
};
</script>

<template>
  <div class="row">
    <div class="col-md-4" v-for="(data, index) in statData" :key="index">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">{{data.title}}</p>
              <h4 class="mb-0">
                {{data.value}}
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="data.loading"></span>
              </h4>
            </div>
            <div class="text-primary">
              <i :class="`${data.icon} font-size-24`"></i>
            </div>
          </div>
        </div>

        <router-link :to="data.url" class="card-body border-top py-3 pointer">
          <div class="text-truncate">
            <span class="badge badge-soft-success font-size-11">
              <i class="ri-arrow-right-line"></i>
              {{data.subvalue}}
            </span>
            <span class="text-muted ml-2">View</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
  <!-- end row -->
</template>